/**
 * Hr api spec
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ReadPositionLocationDto } from './readPositionLocationDto';
import { ReadPositionSkillDto } from './readPositionSkillDto';
import { ReadPositionMetaDto } from './readPositionMetaDto';


export interface ReadPositionDataDto { 
    /**
     * Title of the position
     */
    title?: string;
    /**
     * Company name of the position
     */
    company?: string;
    /**
     * Type of the position
     */
    type?: string;
    /**
     * Date of the position posting
     */
    date?: string;
    /**
     * Description of the position
     */
    description?: string;
    /**
     * Location details of the position
     */
    location?: ReadPositionLocationDto;
    /**
     * Remote work type of the position
     */
    remote?: ReadPositionDataDto.RemoteEnum;
    /**
     * Salary of the position
     */
    salary?: string;
    /**
     * Experience required for the position
     */
    experience?: string;
    /**
     * Responsibilities of the position
     */
    responsibilities?: Array<string>;
    /**
     * Qualifications for the position
     */
    qualifications?: Array<string>;
    /**
     * Skills required for the position
     */
    skills?: Array<ReadPositionSkillDto>;
    /**
     * Metadata of the position
     */
    meta?: ReadPositionMetaDto;
}
export namespace ReadPositionDataDto {
    export const RemoteEnum = {
        Full: 'Full',
        Hybrid: 'Hybrid',
        None: 'None'
    } as const;
    export type RemoteEnum = typeof RemoteEnum[keyof typeof RemoteEnum];
}


